<template>
    <div class="order">
        <van-nav-bar title="学校通讯录" left-arrow @click-left="$router.go(-1)" />

        <div v-if="list.length == 0">
            <van-empty description="暂无记录" />
        </div>
        <div v-else>
            <h5 style="padding: 10px 20px;">学校老师（{{ list.length }}人）</h5>
            <van-row v-for="item, index in list" :key="index"
                style="padding: 10px 10px;margin: 10px 10px;background-color: white;border-radius: 20px;"
                @click="showSheet(item.phone)">
                <van-col span="6">
                    <van-image round width="60px" height="60px" src="/img/teacher.png" />
                </van-col>
                <van-col span="18">
                    <!-- 学生姓名、刷卡时间 -->
                    <p style="font-size: 16px;color: black;font-weight: bold;">{{ item.realname }}(教师)</p>
                    <p style="font-size: 14px;color: grey;" v-if="item.classes.length">
                        <span v-for="value in item.classes" :key="value.id">{{ value + ' ' }}</span>
                    </p>
                    <p style="font-size: 14px;color: grey;">手机号码: {{ item.phone }}</p>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>

import { stuGetTeacherBook } from '@/api/teacher'
export default {
    name: 'stuGetTeacherBook',
    components: {

    },
    data() {
        return {
            list: []
        }
    },
    mounted() {
        this.getBook()
    },
    methods: {
        async getBook() {
            const response = await stuGetTeacherBook()
            console.log('response', response);
            if (response.code == 10000) {
                this.list = response.data
            }
        },
        showSheet(phone) {
            if (!phone) {
                return
            }
            // 拨打电话
            window.location.href = `tel:${phone}`;
        }
    },
    watch: {

    }
}
</script>

<style lang="less" scoped>
.order {
    background-color: #fafafa;
}
</style>
